<div class="modal__content">
  <wfm-patient-banner
    type="skinny"
    [patientsList]="patientsList"
    [isCompressed]="true"
    [isDropdownHidden]="true"
    [isCollapsible]="false">
  </wfm-patient-banner>

  <div>
    <virtual-grid
      [infiniteScrolling]="false"
      [theEnd]="true"
      [disableContextMenu]="true"
      [disableHeaderContextMenu]="true"
      [items]="auditItems"
      [layout]="columns"
      [loading]="loading"
      style="height: 200px"
      class="">
    </virtual-grid>
  </div>
</div>
